import RestClient from './rest-client'

export default class Store extends RestClient {
  static get url () {
    return this.apiUrl + '/stores'
  }
  
  static get paramKey () {
    return 'store'
  }

  async create () {
    const payload = {}
    payload[this.constructor.paramKey] = { ...this }
    const { data } = await this.constructor._post(this.constructor.url, payload)
    this._setAttributes(data.data)

    return data.data
  }

  async getStores (param) {
    const { data } = await this.constructor._get(this.constructor.url, param)
    let stores = data.stores ? data.stores : data.data 
    return stores
  }

  static async saveCodeTiendaNube(store_id, code) {
    const { data } = await this._put(this.url + `/${store_id}/update_code`, {
      code: code
    });

    return data
  }
}
